/*eslint no-unused-expressions: [2, { allowTernary: true }]*/
import React, {
  useEffect,
  useState,
  useRef,
  createRef
} from 'react';
import { Layout, Card, Row, Col, Spin, Input} from 'antd';
import { ProgressBar, PlaybackControls } from './ProgressBar';
import Video from './Video';
import ModelVideo from './ModelVideo';
import './sceneExtract.css';
import useAnimationFrame from './hooks/useAnimationFrame';
import { fetchTimestamps } from "./UserFunctions";
import {Line} from "./Line"
import SceneExtractNavbar from './sceneExtractNavbar';

var plotData = [];
const { Content } = Layout;
const gridStyle = (width, height) => ({
  width,
  height,
});
const border = {"old":"red","new":"blue"}
var plotref = createRef();
var options = {
  tooltips: {
    mode: 'single'
  },
  pan: {
    enabled: false,
    mode: 'xy'
  },
  zoom: {
    enabled: false,
    mode: 'xy' // or 'x' for "drag" version
  },
  animation: {
    duration: 0 // general animation time
  },
  hover: {
    animationDuration: 0 // duration of animations when hovering an item
  },
  responsiveAnimationDuration: 0 // animation duration after a resize
};


export default function DigitalTwin() {
  // states
  const [isPlaying, setIsPlaying] = useState(false);
  const [loading] = useState(false);
  const [loadingTip] = useState('Loading...');
  const [value, setValue] = useState(0);
  const [duration, setDuration] = useState(0);
  const [keys] = useState(["new","old"]);
  const timeline = useRef([0]);
//  const plot = useRef([{x:0,y:0}]);
  const currentTimeRef = useRef(0);
  const [currentTime, setCurrentTime] = useState(0);
  const isPlayingRef = useRef(false);
  const isVideoSeeking =useRef(false);
  const isModelVideoSeeking =useRef(false);

  const handlePlay = () => {
    if (timeline.current.length > 1) {
      isPlayingRef.current = true;
      setIsPlaying(true);
    }
  };
  const handlePause = () => {
    isPlayingRef.current = false;
    setIsPlaying(false);
  };

  const handleChange = (val) => {
    currentTimeRef.current = val;
    setValue(timeline.current[currentTimeRef.current]);
  };
  
  const onVideoSeek = () => {
    isVideoSeeking.current = false;
  }; 

  const onModelVideoSeek = () => {
    isModelVideoSeeking.current = false;
  }; 
  // export default function DigitalTwin() {
  //   // states
  //   const [isPlaying, setIsPlaying] = useState(false);
  //   const [loading] = useState(false);
  //   const [loadingTip] = useState('Loading...');
  //   const [value, setValue] = useState(0);
  //   const [duration, setDuration] = useState(0);
  //   const [keys] = useState(["new","old"]);
  //   const timeline = useRef([0]);
  // //  const plot = useRef([{x:0,y:0}]);
  //   const currentTimeRef = useRef(0);
  //   const [currentTime, setCurrentTime] = useState(0);
  //   const isPlayingRef = useRef(false);
  //   const isVideoSeeking =useRef(false);
  //   const isModelVideoSeeking =useRef(false);
  
  //   const handlePlay = () => {
  //     if (timeline.current.length > 1) {
  //       isPlayingRef.current = true;
  //       setIsPlaying(true);
  //     }
  //   };
  //   const handlePause = () => {
  //     isPlayingRef.current = false;
  //     setIsPlaying(false);
  //   };
  
  //   const handleChange = (val) => {
  //     currentTimeRef.current = val;
  //     setValue(timeline.current[currentTimeRef.current]);
  //   };
    
  //   const onVideoSeek = () => {
  //     isVideoSeeking.current = false;
  //   }; 
  
  //   const onModelVideoSeek = () => {
  //     isModelVideoSeeking.current = false;
  //   }; 
  
  // read samples.csv on first load
  useEffect(() => {
    fetchTimestamps(`${window.location.origin}/get_timestamps`).then( (response) => {
            if(response && response.status === 200) {
                timeline.current = response.data.data
                const tempData = [];
                keys.forEach(signal => {
                  if (typeof signal === 'string') {
                    tempData.push({
                      label:
                      signal.length < 20
                      ? signal
                      : `${signal.slice(0, 10)}...${signal.slice(-10)}`,
                      showLine: true,
                      lineTension: 1,
                      pointStyle: 'circle',
                      radius: 1,
                      borderColor:border[signal],
                      borderWidth: 1,
                      fill: false,
                      data: response.data.plot[signal]
                    })
    }
        });
      plotData = tempData
      plotref.current.chartInstance.data.datasets = tempData
      plotref.current.chartInstance.update()
      setDuration(timeline.current.length);
     }
    })
    console.log(window)
  },);

useEffect(() => {
    setCurrentTime(currentTimeRef.current);
  },[value, isPlaying]);

const renderScreen = (deltaTime) => {
    if (isPlayingRef.current && !isVideoSeeking.current && !isModelVideoSeeking.current) {
      currentTimeRef.current += 1;
      isVideoSeeking.current = true;
      isModelVideoSeeking.current = true;
      if (timeline.current.length - 1 === currentTimeRef.current) {
        setIsPlaying(false);
        isPlayingRef.current = false;
      }
      setValue(timeline.current[currentTimeRef.current]);
    }
  };
//   useEffect(() => {
//     setCurrentTime(currentTimeRef.current);
//   },[value, isPlaying]);

// const renderScreen = (deltaTime) => {
//     if (isPlayingRef.current && !isVideoSeeking.current && !isModelVideoSeeking.current) {
//       currentTimeRef.current += 1;
//       isVideoSeeking.current = true;
//       isModelVideoSeeking.current = true;
//       if (timeline.current.length - 1 === currentTimeRef.current) {
//         setIsPlaying(false);
//         isPlayingRef.current = false;
//       }
//       setValue(timeline.current[currentTimeRef.current]);
//     }
//   };

  
useAnimationFrame(renderScreen);

  // update progress bar regularly

  return (
    <Spin data-test = 'sceneExtractDigitalTwinComponent' spinning={loading} tip={loadingTip}>
      <SceneExtractNavbar />
      <Layout>
        <div className="row">
        <div className="col-lg-12" style = {{backgroundColor: 'white'}}>
        <Content style={{ display: 'flex' }}>
          <div
              className="row"
              style={{
                height: '8vh',
                width: '100%',
                backgroundColor: '#ffffff',
                marginLeft: 'unset',
                marginBottom:'10px',
                padding: 0,
              }}
            >
            <Card className= "col-12" size="small" title="Digital Twin" style={{ height: '8vh',width: '100%', border: '2px solid #aaa',textAlign: 'center',padding: '0px',backgroundColor: '#ffffff' }} />
            </div>
          </Content>
          <Content style={{ display: 'flex' }}>
          <div
              className="row"
              style={{
                height: '8vh',
                width: '100%',
                backgroundColor: '#ffffff',
                marginLeft: 'unset',
                padding: 0,
              }}
            >
            <Card className= "col-6" size="small" title="Raw Video" style={{ height: '8vh', border: '2px solid #aaa',textAlign: 'center',padding: '0px',backgroundColor: '#ffffff' }} />
            <Card className= "col-6" size="small" title="Model Video" style={{ height: '8vh', border: '2px solid #aaa',textAlign: 'center',padding: '0px',backgroundColor: '#ffffff' }} />
            </div>
            </Content>
        <Layout style={{  display: 'flex', flexDirection: 'column',height: '100vh',overflowY: 'hidden' }}>
          <Content style={{ display: 'flex' }}>
            <div
              style={{
                height: '50vh',
                width: '50%',
                backgroundColor: '#ffffff',
                padding: 0,
              }}
            >
              <div
                style={{
                  ...gridStyle('100%', '100%'),
                  border: '2px solid #aaa',
                  borderRight: 'none',
                  padding: '0px',
                }}
              >
                <Video 
                  time={value}
                  onSeek={onVideoSeek}
                 />
              </div>
            </div>
            <div
              style={{
                height: '50vh',
                width: '50%',
                backgroundColor: '#ffffff',
                padding: 0,
              }}
            >
              <div
                style={{
                  ...gridStyle('100%', '100%'),
                  border: '2px solid #aaa',
                  borderRight: 'none',
                  padding: '0px',
                }}
              >
                <ModelVideo 
                  time={value}
                  onSeek={onModelVideoSeek}
                 />
              </div>
            </div>
          </Content>
          <div
                style={{
                  ...gridStyle('100%', '40%'),
                  border: '2px solid #aaa',
                  borderRight: 'none',
                  backgroundColor: 'white',
                  padding: '0px',
                }}
              >
                  <Line
                data={plotData}
                Ref={plotref}
                options={options}
              />
                </div>
          <Card style={gridStyle('100%', '10vh')}>
            <Row align="middle">
              <Col>
                <Input
                  value={value}
                  defaultValue="0.000"
                  disabled
                  style={{ width: '100px' }}
                />
              </Col>
              <Col>
                <PlaybackControls
                  isPlaying={isPlaying}
                  onPlaybackChange={(playing) => {
                    if (playing) {
                      handlePlay();
                    } else {
                      handlePause();
                    }
                  }}
                />
              </Col>
              <Col flex={20}>
                <ProgressBar
                  value={currentTime}
                  onChange={(val) => {
                    setCurrentTime(val);
                    handleChange(val);
                  }}
                  step={1}
                  max={duration}
                />
              </Col>
            </Row>
          </Card>
        </Layout>
        </div>
        </div>
      </Layout>
    </Spin>
  );
}

